import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  removeDocumentById,
  transformIntoDocuments,
  updateWebsocketDocuments,
} from '@freelancer/datastore/core';
import type { GroupMemberRoleApi } from 'api-typings/groups/groups';
import { transformSuperuserGroupMember } from './superuser-group-members.transformer';
import type { SuperuserGroupMembersCollection } from './superuser-group-members.types';

export function superuserGroupMembersReducer(
  state: CollectionStateSlice<SuperuserGroupMembersCollection> = {},
  action: CollectionActions<SuperuserGroupMembersCollection>,
): CollectionStateSlice<SuperuserGroupMembersCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'superuserGroupMembers') {
        const { result, ref, order } = action.payload;

        return mergeDocuments<SuperuserGroupMembersCollection>(
          state,
          transformIntoDocuments(result.members, transformSuperuserGroupMember),
          order,
          ref,
          result.count,
        );
      }

      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'superuserGroupMembers') {
        const { result, ref } = action.payload;

        return mergeWebsocketDocuments<SuperuserGroupMembersCollection>(
          state,
          transformIntoDocuments([result], transformSuperuserGroupMember),
          ref,
        );
      }

      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'superuserGroupMembers') {
        const { originalDocument, delta, ref } = action.payload;

        if (delta.role) {
          return updateWebsocketDocuments<SuperuserGroupMembersCollection>(
            state,
            [originalDocument.id],
            groupMember => ({
              ...groupMember,
              role: delta.role as GroupMemberRoleApi,
            }),
            ref,
          );
        }
      }

      return state;
    }

    case 'API_DELETE_SUCCESS': {
      if (action.payload.type === 'superuserGroupMembers') {
        const { result, ref } = action.payload;

        return removeDocumentById<SuperuserGroupMembersCollection>(
          ref,
          state,
          result.id,
        );
      }

      return state;
    }

    default:
      return state;
  }
}
